import { Checkbox as RefCheckbox, CheckboxProps } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export type { CheckboxProps };
export type { CheckboxChangeEvent };
export const Checkbox = RefCheckbox;
